var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "h-screen flex w-full bg-img vx-row no-gutter items-center justify-center",
      style: { "background-image": "url(" + _vm.imagenFondo + ") !important" },
      attrs: { id: "page-login" }
    },
    [
      _vm.ingresoLogo
        ? _c("img", {
            style: _vm.logoStyle,
            attrs: { src: _vm.ingresoLogo.imagen, id: "logo" }
          })
        : _vm._e(),
      !_vm.isLogged && !_vm.fromCu
        ? _c("b-card", [
            _c("h4", [
              _vm._v(
                "Hola! por favor ingresa tu ClaveÚnica para acceder al formulario."
              )
            ]),
            _c(
              "div",
              { staticClass: "flex flex-wrap mt-5 justify-center" },
              [
                _c("button-clave-unica", {
                  attrs: { size: "lg" },
                  on: {
                    click: function($event) {
                      return _vm.redirectToClaveUnica()
                    }
                  }
                })
              ],
              1
            )
          ])
        : _c(
            "div",
            [
              _c(
                "vs-button",
                {
                  staticClass: "mt-3 ml-3",
                  attrs: { color: "warning", size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.signOut()
                    }
                  }
                },
                [_c("span", [_vm._v("Salir")])]
              ),
              _c("Wizard", { attrs: { "company-to-load": _vm.currentCompany } })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }